module.exports = Object.freeze({
    Pending: 1,
    Published: 2,
    Archived: 3,
    Invalidated: 4
});